<template>
  <div class="">
    <ZnBreadcrumb />
    <div class="main-content" v-title data-title="订单审核_试剂采购库存管理系统">
      <div class="search-type">
        <ul class="clearfix">
          <li>
            <div class="search-item">
              <el-input
                  v-model="searchData.alias"
                  placeholder="请输入试剂名/CAS号/下单人/订单编号"
                  @keyup.enter.native="reviewList()"
                  style="width: 290px"
                  prefix-icon="el-icon-search"
              />
            </div>
            <div class="search-item">
              <label></label>
              <el-select v-model="searchData.auditStatus" placeholder="请选择审核状态" style="width: 154px">
                <el-option label="全部" value=""/>
                <el-option label="待审核" value="1"/>
                <el-option label="已通过" value="2"/>
                <el-option label="未通过" value="3"/>
              </el-select>
            </div>
            <div class="search-item" style="margin-left: 20px">
              <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 300px"
                  v-model="searchData.queryTime"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="search-item" style="margin-left: 20px">
              <el-button type="primary" size="small" @click="reviewList()" v-loading.fullscreen.lock>
                快速查询
              </el-button>
            </div>

            <div class="search-item" style="margin-left: 20px">
              <el-button size="small" @click="handleExportReview()">
                导出Excel
              </el-button>
            </div>
          </li>
        </ul>
        <div>
          <el-row :gutter="24" style = "margin-top: 20px;">
            <el-col :span="3" style="width: auto;">
              <span style="font-size:15px;font-weight: 900;color: black;">总金额：</span>
              <span class="dataClass"><el-input class="dataInput" v-model="auditAmount.totalAmount" :disabled="true"></el-input></span>
            </el-col>
            <el-col :span="3" style="width: auto;">
              <span style="font-size:15px;font-weight: 900;color: black;">待审核：</span>
              <span class="dataClass"><el-input class="dataInput" v-model="auditAmount.waitAmount" :disabled="true"></el-input></span>
            </el-col>
            <el-col :span="2" style="width: auto;">
              <span style="font-size:15px;font-weight: 900;color: black;">通过：</span>
              <span class="dataClass"><el-input class="dataInput" v-model="auditAmount.successAmount" :disabled="true"></el-input></span>
            </el-col>
            <el-col :span="2" style="width: auto;">
              <span style="font-size:15px;font-weight: 900;color: black;">驳回：</span>
              <span class="dataClass"><el-input class="dataInput" v-model="auditAmount.failAmount" :disabled="true"></el-input></span>
            </el-col>
            <el-col :span="3" style="width: auto;">
              <span style="font-size:15px;font-weight: 900;color: black;">采购量：</span>
              <span class="dataClass"><el-input class="dataInput" v-model="auditAmount.reagentNum" :disabled="true"></el-input></span>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="inventory-library table-container" style="height: 80%">
        <el-table
          :data="orderList"
          height="100%"
          :span-method="objectSpanMethod"
          :header-cell-style="{
            background: '#F8FAFC',
            color: 'rgba(0, 0, 0, 0.85)',
            fontWeight: 700,
            height: '54px',
          }"
          border
          style="width: 100%"
          :row-style="tableRowStyle1"
        >
          <template slot="empty">
            <img src="../../assets/images/empty.png" class="empty" />
            <p>暂无订单详情</p>
          </template>
          <el-table-column prop="lockerOrders.gmtCreate" width="155px" label="购买时间">
          </el-table-column>
          <el-table-column prop="lockerOrders.nickName" label="下单人"></el-table-column>
          <el-table-column prop="goodsName" label="试剂名称"> </el-table-column>
          <el-table-column prop="casNo" label="CAS号"> </el-table-column>
          <el-table-column prop="casNo" label="结构式" width="80px">
            <template v-slot="scope">
              <el-image style="width:50px;height:50px;" class="structionImg" :src="scope.row.structionImg" alt="" :preview-src-list="[scope.row.structionImg]">
                <div slot="error" class="image-slot" >
                  <div style="width: 50px;height: 50px;line-height: 50px;text-align: center;background-color:#f5f7fa;color: #c0c4cc" >暂无</div>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="supplierBrand" label="品牌" width="80px"> </el-table-column>
          <el-table-column prop="supplierName" label="供应商" width="80px"></el-table-column>
          <el-table-column prop="specNames" label="规格" :show-overflow-tooltip="true"/>

          <el-table-column prop="casNo" label="剂量" width="80px">
            <template slot-scope="scope">
              <span v-if="scope.row.lockerOrders.orderType == 1">
                {{ scope.row.packageType }}
              </span>
              <span v-if="scope.row.lockerOrders.orderType == 0">
                {{ scope.row.weight }} {{ $store.state.unit[scope.row.weightUnit] }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="购买量" width="80px"> </el-table-column>
          <el-table-column prop="orderItemAmount" label="单价" width="120px">
            <template slot-scope="scope">
              <span v-if="scope.row.salesPriceTask">{{ scope.row.salesPriceTask/scope.row.num}}元</span>
              <span v-else>{{ scope.row.salesPrice/scope.row.num }}元</span>
            </template>
          </el-table-column>
          <el-table-column prop="lockerOrders.orderAmount" label="总金额" width="120px">
            <template slot-scope="scope">
              <span v-if="null != scope.row.lockerOrders.orderAmountTask">{{ scope.row.lockerOrders.orderAmountTask }}元</span>
            </template>
          </el-table-column>
          <el-table-column prop="lockerOrders.orderNo" label="订单编号">
          </el-table-column>
          <el-table-column label="审核状态">
            <template slot-scope="scope">
              <span
                v-if="scope.row.lockerOrders.auditStatus == '待审核'"
                class="undo status"
                >{{ scope.row.lockerOrders.auditStatus }}</span>
              <span
                v-if="scope.row.lockerOrders.auditStatus == '已通过'"
                class="pass status"
                >{{ scope.row.lockerOrders.auditStatus }}</span
              >
              <span
                v-if="scope.row.lockerOrders.auditStatus == '未通过'"
                class="refused status"
                >{{ scope.row.lockerOrders.auditStatus }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="num" label="审批">
            <template slot-scope="scope">
              <img
                @click="orderPass(scope.row)"
                v-if="scope.row.lockerOrders.auditStatus == '待审核'"
                src="../../assets/private/审核通过.png"
                title="审核通过"
                style="height: 25px; width: 25px; float: left"
              />

              <img
                @click="showRefusedDia(scope.row)"
                v-if="scope.row.lockerOrders.auditStatus == '待审核'"
                src="../../assets/private/审核不通过.png"
                title="审核拒绝"
                style="height: 25px; width: 25px; float: left"
              />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="float: right"
          :pager-count="5"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagesdata.pageNum"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pagesdata.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 拒绝审核 -->
      <el-dialog
        title="不同意采购"
        :visible.sync="dialogRefused"
        class="reviewDia"
        width="460px"
      >
        <textarea
          name=""
          id=""
          v-model="refusalReason"
          placeholder="请输入拒绝原因，限制50字内"
          maxlength="50"
        ></textarea>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogRefused = false">取 消</el-button>
          <el-button type="primary" @click="refusedReview()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {EventBus} from "@/config/event-bus";

export default {
  data() {
    return {
      amount:{
        orderAmount:null,
        successOrder:null,
        failOrder:null,
        waitOrder:null,
      },

      auditAmount:{
        //总金额
        totalAmount:null,
        //待审核金额
        waitAmount:null,
        //通过金额
        successAmount:null,
        //驳回金额
        failAmount:null,
        //采购量
        reagentNum:null,
        //取消金额
        cancelAmount: null
      },
      num: 1,
      dialogRefused: false,
      formLabelWidth: "120px",
      orderList: [],
      refusalReason: "",
      alias: "",
      total: 0,
      totalpage: 0,
      pagesdata: {
        pageNum: 1,
        pageSize: 10,
      },
      searchData: {
        alias: "",
        auditStatus: null,
        pageNum: 1,
        pageSize: 10,
        queryTime: [],
        startTime: null,
        endTime: null
      },
      spanArr: [], //遍历数据时，根据相同的标识去存储记录
      position: 0, // 二维数组的索引
      mergeColIndex: [0, 1,11,12,13,14], // 要合并的列的序号，从0 开始
    };
  },
  created() {
    this.reviewList();
    this.getOrderStat();
  },

  methods: {
    tableRowStyle1({row, rowIndex}){
      var orders = row.lockerOrders;
      if('待审核' == orders.auditStatus){
        let styleColor = {"color":"#F18F41"};
        return styleColor;
      }
    },
    handleExportReview(){
      this.searchData.startTime = null;
      this.searchData.endTime = null;
      if(null != this.searchData.queryTime && this.searchData.queryTime.length > 0){
        this.searchData.startTime = this.searchData.queryTime[0];
        this.searchData.endTime = this.searchData.queryTime[1];
      }
      let params = this.searchData;
      const resp = this.$apiFetch
          .download("/lockerOrders/exportExecl", params)
          .then((resp) => this.downloadFile(resp,'订单审核表'));
    },
    getOrderStat(){
      this.$apiFetch
        .get(`/lockerOrders/orderStatistics`)
        .then((res)=>{
          console.log(res,"haha")
          this.amount.orderAmount = res.data.orderAmount;
          this.amount.successOrder = res.data.successOrder;
          this.amount.failOrder = res.data.failOrder;
          this.amount.waitOrder = res.data.waitOrder;
          console.log(this.amount.waitOrder,"xixi")
        })
    },
    getSpanArr(data) {
      this.spanArr = []; // 避免表格错乱！
      data.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else {
          console.log("haha", data[index].lockerOrders.orderNo);
          if (
            data[index].lockerOrders.orderNo ===
            data[index - 1].lockerOrders.orderNo
          ) {
            // 这里是要合并行
            this.spanArr[this.position] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.position = index;
          }
        }
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.mergeColIndex.indexOf(columnIndex) != -1) {
        // 对第一列进行合并
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },

    // 分页 size 改变
    handleSizeChange(val) {
      this.pagesdata.pageSize = val;
      this.searchData.pageSize = val;
      // this.searchData.pageNum = this.page.currentPage;
      // this.searchData.pageSize = this.page.pageSize
      this.reviewList();
    },
    // 当前 页码 改变
    handleCurrentChange(val) {
      this.pagesdata.pageNum = val;
      this.searchData.pageNum = val;
      // this.searchData.pageNum = this.page.currentPage;
      // this.searchData.pageSize = this.page.pageSize
      this.reviewList();
    },
    orderAuditStatistics(){
      this.searchData.startTime = null;
      this.searchData.endTime = null;
      if(null != this.searchData.queryTime && this.searchData.queryTime.length > 0){
        this.searchData.startTime = this.searchData.queryTime[0];
        this.searchData.endTime = this.searchData.queryTime[1];
      }
      const params = this.searchData;
      this.$apiFetch
          .get(`/lockerOrders/orderAuditStatistics`,
              {alias: params.alias,auditStatus: params.auditStatus,startTime: params.startTime,endTime: params.endTime})
          .then((res) => {
            this.auditAmount = res.data;
          });
    },
    //订单审核列表
    reviewList() {
      this.searchData.startTime = null;
      this.searchData.endTime = null;
      if(null != this.searchData.queryTime && this.searchData.queryTime.length > 0){
        this.searchData.startTime = this.searchData.queryTime[0];
        this.searchData.endTime = this.searchData.queryTime[1];
      }
      let params = this.searchData;
      const { pageNum, pageSize } = this.pagesdata;
      this.$apiFetch
        .get(`/lockerOrders/orderAuditPage`, params)
        .then((res) => {
          res.data.list.map((item) => {
            if (item.auditTime) {
              item.auditTime = item.auditTime.substring(0, 11);
            }
            // item.orderTime = item.orderTime.substring(0, 11);
            if (item.lockerOrders.auditStatus == 0) {
              item.lockerOrders.auditStatus = "-";
            } else if (item.lockerOrders.auditStatus == 1) {
              item.lockerOrders.auditStatus = "待审核";
            } else if (item.lockerOrders.auditStatus == 2) {
              item.lockerOrders.auditStatus = "已通过";
            } else if (item.lockerOrders.auditStatus == 3) {
              item.lockerOrders.auditStatus = "未通过";
            } else if (item.lockerOrders.auditStatus == 4) {
              item.lockerOrders.auditStatus = "洛济取消";
            } else if (item.lockerOrders.auditStatus == 10) {
              item.lockerOrders.auditStatus = "-";
            }
          });
          this.orderList = res.data.list;
          this.total = res.data.total;
          this.totalpage = res.data.pages;
          this.getSpanArr(this.orderList);
        });
      this.orderAuditStatistics();
    },
    //商品详情
    goodsDetails(row) {
      let id = row.id;
      let price = row.payAmount;
      let No = row.orderNo;
      this.$router.push({
        path: `goodsDetailsSh/${id}?price=${price}&No=${No}`,
      });
    },
    //通过
    orderPass(row) {
      let id = row.ordersId;
      this.$apiFetch.get(`/lockerOrders/auditPass?id=${id}`).then(() => {
        this.reviewList();
        this.$apiFetch
            .get("/lockerOrders/getUnCheckedOrder")
            .then((res) => {
              localStorage.setItem("UnCheckedOrder",res.data);
              this.unCheckedOrder = localStorage.getItem("UnCheckedOrder");
              EventBus.$emit('UnCheckedOrder',res.data);
            });
      });
    },
    //拒绝弹框
    showRefusedDia(row) {
      this.id = row.ordersId;
      this.dialogRefused = true;
    },
    //拒绝
    refusedReview() {
      let id = this.id;
      let refusalReason = this.refusalReason;
      let params = {
        id,
        refusalReason,
      };
      this.$apiFetch.put(`/lockerOrders/auditRefuse`, params).then(() => {
        this.dialogRefused = false;
        this.reviewList();
      });
    },
    changePage(data) {
      this.pagesdata.pageNum = data;
      this.reviewList();
    },
  },
};
</script>
<style lang="less">
.dataClass  .dataInput .el-input__inner {
  width: 110px;height: 30px;
  background-color: #f5f7fa;
  color: #606266;
}
.dataClass .el-color-picker__icon, .el-input, .el-textarea {
  width: auto;
}
</style>
<style lang="less" scoped>
/deep/.el-table__empty-block {
  min-height: 200px;
  margin: 38px 0;

  img {
    width: 148px;
  }
  p {
    color: #b1c4e2;
    font-size: 14px;
    line-height: 20px;
    margin-top: 14px;
    text-align: center;
  }
}
.search-type {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #eef2f8;
  ul {
    li {
      position: relative;
      display: flex;
      align-items: center;
      .el-input{
        margin: 0 var(--zng-gap) 0 10px;
        width: 360px;
      }
      /*  img {
        position: absolute;
        width: 14px;
        left: 9px;
        top: 11px;
      }
      input {
        width: 380px;
        height: 36px;
        padding-left: 28px;
        margin-right: var(--zng-gap);
        border-radius: 4px;
        border: 1px solid #cccccc;
      } */
      /* button {
        width: 98px;
        height: 36px;
        background: #478aff;
        border-radius: 4px;
        font-size: 12px;
        color: #ffffff;
        margin-left: 12px;
      } */
    }
  }
}
.table-container {
  border-radius: 4px;
  padding: 20px;
  background-color: #ffffff;

  .refused-btn {
    color: #ff4d4f;
  }
  span.status {
    padding-left: 15px;
  }
  span.status::before {
    width: 5px;
    height: 5px;
    background: #fa8c16;
    border-radius: 50%;
    content: "";
    position: absolute;
    left: 10px;
    top: 8px;
  }
  span.pass::before {
    background-color: #52c41a;
  }
  span.refused::before {
    background-color: #ff4d4f;
  }
}

.inventory-library {
  .table-handel {
    float: right;
    span {
      color: #666666;
      font-weight: normal;
      i {
        color: #fa8c16;
      }
    }
    span.to-see {
      padding-left: 24px;
      color: #333333;
      font-weight: 400;
      cursor: pointer;
    }
  }
}
/deep/ .el-table .cell {
  display: flex;
  position: relative;
  .el-button {
    flex: auto;
    text-align: left;
  }
}
.reviewDia {
  textarea {
    width: 398px;
    height: 125px;
    background: #fafafa;
    border-radius: 4px;
    padding: 14px 18px;
    color: #999999;
    box-sizing: border-box;
    font-family: PingFangSC-Regular, PingFang SC;
  }
}
</style>
